import { render, staticRenderFns } from "./softwareTableSimulation.vue?vue&type=template&id=5e22e8f6&"
import script from "./softwareTableSimulation.vue?vue&type=script&lang=js&"
export * from "./softwareTableSimulation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports